module.exports = __webpack_public_path__ + "img/3_hills.0a0cac47.jpg";